import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { text } from "../helpers";

var root = $.from_html(`<p class="slex-paragraph"> </p>`);

export default function Paragraph($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var p_1 = root();
	var text_1 = $.child(p_1, true);

	$.reset(p_1);

	$.template_effect(
		($0) => {
			$.set_attribute(p_1, 'data-tone', $.get(p).tone === "lead" ? "lead" : "body");
			$.set_text(text_1, $0);
		},
		[
			() => text($.get(p).text ?? $.get(p).content ?? $.get(p).label)
		]
	);

	$.append($$anchor, p_1);
	$.pop();
}